<template>
  <x-page title="我的盒柜">
    <!-- 分类栏 -->
    <x-sticky>
      <van-tabs
        v-model="currentCategoryIndex"
        title-active-color="rgba(255, 17, 28, 1)"
        @click="
          index =>
            $track.push({
              name: '我的盒柜-分类栏',
              content: categoryList[index].label,
              id: 'b1edfdce-262d-43e9-817c-49f4d5019382',
            })
        "
      >
        <van-tab
          v-for="cat in categoryList"
          :key="cat.value"
          :title="cat.label"
        />
      </van-tabs>
    </x-sticky>

    <!-- 列表 -->
    <div :class="_.list">
      <x-waterfall ref="list" :load="handleLoad">
        <template #default="{ data }">
          <div
            v-for="(item, index) in data"
            :key="item.orderId"
            :class="_.item"
          >
            <!-- 状态，仅未开盒 -->
            <div v-if="item.status === 1" :class="_.status">
              <div :class="_.time">
                <div :class="_.label">自动开盒倒计时：</div>
                <van-count-down
                  :class="_.value"
                  :time="item.countDownConfig.openBoxTime * 1000"
                  format="DD 天 HH 时 mm 分 ss 秒"
                  @finish="$reloadWaterfall('list')"
                />
              </div>
              <div :class="_.text">待开盒</div>
            </div>

            <!-- 状态，仅已开盒 -->
            <div v-if="item.status === 2" :class="_.status">
              <div :class="_.time">
                <div :class="_.label">回收倒计时：</div>
                <van-count-down
                  :class="_.value"
                  :time="item.countDownConfig.deliverTime * 1000"
                  format="DD 天 HH 时 mm 分 ss 秒"
                  @finish="$reloadWaterfall('list')"
                />
              </div>
            </div>

            <!-- 提示，仅自动退款的 -->
            <div v-if="item.status === 6" :class="_.tips">
              {{ item.errorReason }}
            </div>

            <!-- 头，仅已开盒的 -->
            <div v-if="item.status !== 1" :class="_.hd">
              <img :src="item.boxPic" :class="_.logo" />
              <div :class="_.name">{{ item.boxName }}</div>
            </div>

            <!-- 内容 -->
            <div
              :class="[_.bd, _._hairlineTop]"
              @click="handleOrderClick(item)"
            >
              <!-- 盒子信息，待开盒时显示 -->
              <div v-if="item.status === 1" :class="_.box">
                <img
                  :src="require('./images/待开盒封面图.png')"
                  :class="_.cover"
                />
                <div :class="_.content">
                  <div :class="_.name">{{ item.boxName }}</div>
                  <div :class="_.actions">
                    <div
                      v-track="{
                        name: '去开盒',
                        id: 'fa4b8723-eb3e-4766-97b6-c346dc97c842',
                        resource: {
                          id: item.boxId,
                          name: item.boxName,
                        },
                        index: index,
                      }"
                      :class="_.button"
                      @click.stop="handleOpenClick(item)"
                    >
                      去开盒
                    </div>
                  </div>
                </div>
              </div>
              <!-- 商品信息，已开盒时显示 -->
              <div v-if="item.status !== 1" :class="_.goods">
                <img :src="item.commodityPic" :class="_.cover" />
                <div :class="_.content">
                  <div :class="[_.name, _._ellipsis2]">
                    {{ item.commodityTitle }}
                  </div>
                  <div :class="_.price">¥{{ item.commodityPrice }}</div>
                </div>
              </div>
            </div>

            <!-- 底部 -->
            <div v-if="item.status !== 1" :class="_.ft">
              <div
                v-if="item.status === 2"
                v-track="{
                  name: '我要回收',
                  id: 'f27f7558-8e4a-4b04-a0dd-55cf3f4587bb',
                  resource: {
                    id: item.boxId,
                    name: item.boxName,
                  },
                  index: index,
                }"
                :class="[_.button, _.secondary]"
                @click="handleRefundClick(item)"
              >
                我要回收
              </div>
              <div
                v-if="item.status === 2"
                v-track="{
                  name: '立即发货',
                  id: 'a065c24f-29ae-44f3-bec2-7df42535fa8f',
                  resource: {
                    id: item.boxId,
                    name: item.boxName,
                  },
                  index: index,
                }"
                :class="_.button"
                @click="handleRequestDeliveryClick(item)"
              >
                立即发货
              </div>
              <div
                v-if="item.status === 3"
                v-track="{
                  name: '查看详情',
                  id: '32222bbd-50ba-41e0-b4b7-8631e2f464f0',
                  resource: {
                    id: item.boxId,
                    name: item.boxName,
                  },
                  index: index,
                }"
                :class="_.button"
                @click="handleDetailClick(item)"
              >
                查看详情
              </div>
              <div
                v-if="item.status === 4 || item.status === 6"
                v-track="{
                  name: '查看退款信息',
                  id: '279f3530-f315-4e05-92a4-25c9cbefd246',
                  resource: {
                    id: item.boxId,
                    name: item.boxName,
                  },
                  index: index,
                }"
                :class="[_.button, _.secondary]"
                @click="handleRefundResultClick(item)"
              >
                退款详情
              </div>
            </div>
          </div>
        </template>
        <x-empty slot="empty" type="列表" message="暂时没有盲盒哦~" />
      </x-waterfall>
    </div>

    <RefundDialog
      v-model="showRefundDialog"
      :goods="refundOrderData"
      :order-id="refundOrderData.orderId"
    />

    <DeliveryDialog
      v-model="showDeliveryDialog"
      :goods="deliveryOrderData"
      :order-id="deliveryOrderData.orderId"
    />
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import { addDispose, mapQuery, submit, Track } from '@/utils'
  import { apiBlindBoxOrderGetOrderUrl, apiBlindBoxOrderList } from '@/api'
  import { boxBus } from './bus'
  import { dcb } from '@dcb/jssdk'
  import { DeliveryDialog, RefundDialog } from './components'
  import { navigateTo } from '@/router'

  export default Vue.extend({
    components: {
      RefundDialog,
      DeliveryDialog,
    },

    mixins: [
      mapQuery({
        active: 'active',
      }),
      Track.provideMark(() => ({
        page: '多多盲盒订单列表页',
      })),
    ],

    data: () => ({
      // 当前分类索引
      currentCategoryIndex: 0,
      // 分类列表
      categoryList: [
        {
          label: '全部',
          value: 0,
        },
        {
          label: '待开盒',
          value: 1,
        },
        {
          label: '已开盒',
          value: 2,
        },
        {
          label: '已出仓',
          value: 3,
        },
        {
          label: '已回收',
          value: 4,
        },
      ],
      refundOrderData: {},
      showRefundDialog: false,
      deliveryOrderData: {},
      showDeliveryDialog: false,
    }),

    watch: {
      currentCategoryIndex() {
        this.$reloadWaterfall('list')
      },
    },

    created() {
      this.currentCategoryIndex = (this.active && Number(this.active)) || 0

      addDispose(
        this,
        boxBus.on('shouldRefreshOrderList', () => {
          this.$reloadWaterfall('list')
        }),
      )
    },

    methods: {
      handleLoad({ pageNumber }) {
        return apiBlindBoxOrderList({
          pageIndex: pageNumber,
          pageSize: 10,
          status:
            this.categoryList[this.currentCategoryIndex].value || undefined,
        }).then(res => {
          res.list = res.list.filter(
            item =>
              // 已开盒但剩余回收时间为 0 的予以过滤
              !(item.status === 2 && item.countDownConfig.deliverTime === 0),
          )
          return res
        })
      },

      handleOpenClick(item) {
        navigateTo('BoxOpen', {
          id: item.boxId,
          orderId: item.orderId,
          fromOrderList: true,
        })
      },

      handleRefundClick(item) {
        this.refundOrderData = item
        this.showRefundDialog = true
      },

      handleDetailClick(item) {
        submit(async $ => {
          $.start()
          const url = await apiBlindBoxOrderGetOrderUrl({
            id: item.orderId,
          })
          dcb.navigateTo({
            url: url,
          })
        })
      },

      handleRefundResultClick(item) {
        navigateTo('BoxRefundResult', {
          orderId: item.orderId,
        })
      },

      handleRequestDeliveryClick(item) {
        this.deliveryOrderData = item
        this.showDeliveryDialog = true
      },

      handleOrderClick(item) {
        if (item.commodityId) {
          navigateTo('GoodsIndex', {
            id: item.commodityId,
          })
        }
      },
    },
  })
</script>

<style lang="scss" module>
  .list {
    padding: 16px 12px;

    .item {
      background: #ffffff;
      border-radius: 8px;
      padding: 12px;

      .status {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 12px;

        .time {
          display: flex;
          align-items: center;
          font-size: 13px;
          line-height: 18px;

          .label {
            color: #666666;
          }

          .value {
            color: #ff960a;
          }
        }

        .text {
          font-size: 14px;
          color: #ff111c;
          line-height: 20px;
        }
      }

      .tips {
        font-size: 16px;
        font-weight: var(--bold-value);
        color: #ff9000;
        line-height: 22px;
        padding-bottom: 14px;
      }

      .hd {
        display: flex;
        align-items: center;
        padding-bottom: 12px;

        .logo {
          flex-shrink: 0;
          width: 26px;
          height: 26px;
          background: #ffffff;
          border: 1px solid #e4e4e4;
          border-radius: 50%;
          object-fit: cover;
        }

        .name {
          margin-left: 12px;
          flex-grow: 1;
          font-size: 16px;
          font-weight: bold;
          color: #222222;
          line-height: 22px;
        }
      }

      .bd {
        padding-top: 12px;

        .box {
          display: flex;
          align-items: stretch;

          .cover {
            flex-shrink: 0;
            width: 85px;
            height: 85px;
            border-radius: 8px;
            object-fit: cover;
          }

          .content {
            flex-grow: 1;
            margin-left: 12px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .name {
              font-size: 14px;
              color: #222222;
              line-height: 20px;
            }

            .actions {
              display: flex;
              align-items: center;
              justify-content: flex-end;

              .button {
                width: 86px;
                height: 30px;
                background: rgba(#ff111c, 0.93);
                border-radius: 17px;
                font-size: 14px;
                color: #ffffff;
                line-height: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
              }
            }
          }
        }

        .goods {
          display: flex;
          align-items: flex-start;

          .cover {
            flex-shrink: 0;
            width: 85px;
            height: 85px;
            border-radius: 8px;
            object-fit: cover;
          }

          .content {
            margin-left: 12px;
            display: flex;
            flex-direction: column;

            .name {
              font-size: 14px;
              color: #222222;
              line-height: 20px;
            }

            .price {
              margin-top: 12px;
              font-size: 14px;
              color: #222222;
              line-height: 20px;
            }
          }
        }
      }

      .ft {
        margin-top: 12px;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .button {
          background: rgba(#ff111c, 0.93);
          border-radius: 1000px;
          font-size: 14px;
          color: #ffffff;
          line-height: 20px;
          padding: 5px 15px;
          box-sizing: border-box;

          &.secondary {
            border: 1px solid #bebebe;
            background: white;
            color: #222222;
          }

          &:not(:first-child) {
            margin-left: 12px;
          }
        }
      }

      &:not(:first-child) {
        margin-top: 12px;
      }
    }
  }
</style>
